// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"generation-info-card_infoCardContainer__cah7Q"};